export default __webpack_public_path__ + "static/media/misc-closetC-1440w.ae8db54f.webp";